import React from "react";
import { Space, Icon, Text, ExternalAnchor } from "../../components";
import routes from "../../routes";
import { TEXT_404 } from "./constants";
import {
  StyledBg,
  StyledStatusCodeText,
  StyledText404Desc,
  StyledSmallText,
  StyledButton,
} from "./styled";

const Page500 = () => {
  return (
    <StyledBg>
      <StyledStatusCodeText>{TEXT_404}</StyledStatusCodeText>
      <StyledText404Desc color="currentColor">
        This is not the page you were looking for. . .
      </StyledText404Desc>
      <StyledSmallText color="currentColor">And that’s on us.</StyledSmallText>
      <Space margins={[6, 0, 0, 0]}>
        <StyledButton>
          <Icon
            name="arrowBack"
            size="32px"
            margin="0 8px 0 0"
            color="primary"
          />
          <ExternalAnchor href={routes.HOME} isLandingPage>
            <Text isInline size="24px" color="primary">
              Go back home
            </Text>
          </ExternalAnchor>
        </StyledButton>
      </Space>
    </StyledBg>
  );
};

export default Page500;
